import { Button, FileDrop, Modal } from '@scuf/common';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    open: boolean;
    onAccept: CallableFunction;
    onReset: VoidFunction;
    onClose: VoidFunction;
};

const FilesModal: React.FC<Props> = ({ open, onAccept, onReset, onClose }: Props) => {
    const { t } = useTranslation(['common']);

    return (
        <Modal size="small" open={open} onClose={onClose}>
            <FileDrop
                label={t('translation.File').toUpperCase()}
                placeholder={t('actions.Draganddropfileshere')}
                onAccepted={(files) => onAccept(files)}
                buttonText={t('common:actions.BrowseFiles')}
                onReset={onReset}
                multiple
            />
            <div
                style={{
                    marginTop: '8px',
                    marginBottom: '8px',
                    fontSize: '12px',
                    color: '#555',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <p>
                    {t('common:actions.SuggestPDF')} <b>PDF</b>
                </p>
            </div>
            <div className="buttonsSearch">
                <Button onClick={onClose}>{t('actions.Close')}</Button>
            </div>
        </Modal>
    );
};

export default FilesModal;